
const AboutBody = () => {
  return (
    <section className="section-spacing-80 no-padding-top cloudy-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="page-body-content-container width-600 margin-auto relative">
              <div className="about-body-content">
                <div className="about-body-section">
                  <h2>Overview</h2>

                  <p>
                    Flexi Painters is a Kampala-based professional painting
                    company setting higher standards for professional painting
                    services across Uganda.
                  </p>
                  <p>
                    We do painting, spraying, and decoration finishes for
                    residential, commercial, and industrial properties.
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Our Services</h2>

                  <p>
                    We provide interior painting, exterior painting, decorative
                    finishes, spray painting, and full surface preparation for
                    residential, commercial, and industrial properties.
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Background</h2>
                  <p>
                    Flexi Painters, also known as Kampala Painters was founded
                    by Mr. Alex Mukasa, a senior painter with over a decade
                    experience painting all kinds of properties. He started as a
                    learner painter earning less than a dollar per day from a
                    one generous old man of color who opted to teach him all
                    there is about painting, decoration and colors.
                  </p>
                  <p>
                    When Alex learned and his experience increased, he was
                    graduated and then started out as Alex Painter until he
                    formalized to Flexi Painters World and Services LTD.
                  </p>
                  <p>
                    Today, Flexi Painters is a Kampala-based professional
                    painting company setting higher standards for professional
                    painting services across Uganda.
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Who We Are</h2>
                  <p>
                    As trusted painters in Kampala, we are known for disciplined
                    execution, clean job sites, and results that maintain their
                    quality and beauty over time. 
                  </p>
                  <p>
                    We work with clients who expect more than basic results —
                    clients who want more than just color and value clean
                    execution, precision, and finishes that are beautiful and
                    built to last.
                  </p>
                  <p>
                    At Flexi Painters, painting is not just a service. It is a
                    standard. And we are committed to raising it.
                  </p>
                  <p>
                    Whether you are looking for a painter in Kampala or reliable
                    painters anywhere in Uganda, Flexi Painters delivers work
                    you can depend on — without excuses.
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Why Choose Flexi Painters?</h2>
                  <p>
                    In a market where poor workmanship, delays, and inconsistent
                    quality are common, Flexible Painters stands out for one
                    reason: we deliver exactly what we promise.
                  </p>
                  <p>
                    We don’t cut corners. We don’t compromise on preparation.
                    And we don’t leave projects unfinished or inconsistent.
                  </p>

                  <p>
                    Our team is large and trained to handle projects of any
                    scale — from private homes to large commercial developments
                    — with the same level of precision and control.
                  </p>
                  <p>
                    Every stage of our process — from surface preparation to
                    final finishing — is handled with intention, using proven
                    techniques and quality materials to deliver strong, durable,
                    and visually sharp results.
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Our Mission</h2>

                  <p>
                    To set and maintain the highest standards for painting
                    services by delivering consistent, high-quality results
                    without compromise.
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Our Vision</h2>

                  <p>
                    To become the benchmark painting company in Kampala and
                    across Uganda — the name clients trust and competitors
                    measure themselves against.
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Our Core Values</h2>

                  <p>
                    <span className="flexi-orange">✔︎ </span> Precision – Every
                    detail matters
                  </p>
                  <p>
                    <span className="flexi-orange">✔︎ </span> Reliability – We
                    deliver as promised
                  </p>
                  <p>
                    <span className="flexi-orange">✔︎ </span> Clean Work –
                    Professional and neat execution
                  </p>
                  <p>
                    <span className="flexi-orange">✔︎ </span> Quality – We use
                    proven materials and methods
                  </p>
                  <p>
                    <span className="flexi-orange">✔︎ </span> Customer Focus –
                    Client satisfaction is our priority
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Our Impact</h2>

                  <p>
                    <span className="flexi-orange">✔︎ </span> 100+ – Properties
                    Painted
                  </p>
                  <p>
                    <span className="flexi-orange">✔︎ </span> 10+ – Years of
                    experience
                  </p>
                </div>
                <div className="about-body-section">
                  <h2>Ready to have your property professionally painted?</h2>

                  <p>
                    1. Give us a call on{" "}
                    <a href="tel:+256775866449">+256-775-866-449</a>
                  </p>
                  <p>
                    2. Send an emaill on{" "}
                    <a href="mailto:flexipainters@gmail.com">
                      info@flexipainters.com
                    </a>
                  </p>
                  <p>
                    3. Send a WhatsApp message on{" "}
                    <a
                      href="https://wa.me/256775866449"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      24/7 WhatsApp Chat
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBody;
